import { CloseIcon } from "components/atoms/Icon";
import Modal from "components/atoms/modal";

function SafariAllowPopupInfoModal({ open, closeModal }: { open: boolean; closeModal: () => void }) {
  return (
    <Modal open={open} onClose={closeModal} additionalClasses="!bg-opacity-10">
      <div className="rounded-xl border border-white bg-primary p-8">
        <div className="flex w-[530px] max-w-[calc(80vw)] flex-col  2xl:w-[620px]">
          <button type="button" className="-mt-4 mb-3 self-end p-1" onClick={closeModal}>
            <CloseIcon className="h-5 w-5 text-white" />
          </button>
          <div className="space-y-7">
            <p className="font-satoshi text-xxs font-semibold leading-5 text-white md:text-sm md:leading-7  2xl:text-lg">
              To enable pop-ups on Safari using iOS, you will need to head to your settings page and then scroll down to
              Safari. From there, scroll to the General section and then toggle the Block Pop-ups button to off.
            </p>
            <img
              src="/safari_enable_popup.webp"
              alt="safari_enable_popup_image"
              className=" mx-auto aspect-[2.13/1] w-full object-cover"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default SafariAllowPopupInfoModal;
